import React from 'react';
import { useLanguage } from './LanguageContext';

const translations = {
  en: {
    tagline: 'AI-powered cooking for everyone',
    quickLinks: 'Quick Links',
    legal: 'Legal',
    social: 'Follow Us',
    copyright: '© 2024 24AI Cooking. All rights reserved.',
    home: 'Home',
    features: 'Features',
    howItWorks: 'How It Works',
    privacy: 'Privacy Policy',
    terms: 'Terms of Service'
  },
  sl: {
    tagline: 'Kuhanje z umetno inteligenco za vse',
    quickLinks: 'Hitre povezave',
    legal: 'Pravno',
    social: 'Sledite nam',
    copyright: '© 2024 24AI Cooking. Vse pravice pridržane.',
    home: 'Domov',
    features: 'Funkcije',
    howItWorks: 'Kako deluje',
    privacy: 'Politika zasebnosti',
    terms: 'Pogoji uporabe'
  }
};

const Footer = () => {
  const { language } = useLanguage();
  const t = translations[language];

  return (
    <footer className="bg-dark text-white py-12 px-4">
      <div className="container mx-auto max-w-6xl">
        <div className="grid md:grid-cols-3 gap-8 mb-8">
          <div>
            <h3 className="text-2xl font-bold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              24AI Cooking
            </h3>
            <p className="text-gray-300" style={{ fontFamily: 'Lato, sans-serif' }}>
              {t.tagline}
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {t.quickLinks}
            </h4>
            <ul className="space-y-2" style={{ fontFamily: 'Lato, sans-serif' }}>
              <li><a href="#" className="text-gray-300 hover:text-white transition">{t.home}</a></li>
              <li><a href="#features" className="text-gray-300 hover:text-white transition">{t.features}</a></li>
              <li><a href="#how-it-works" className="text-gray-300 hover:text-white transition">{t.howItWorks}</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4" style={{ fontFamily: 'Poppins, sans-serif' }}>
              {t.legal}
            </h4>
            <ul className="space-y-2" style={{ fontFamily: 'Lato, sans-serif' }}>
              <li><a href="/privacy.html" className="text-gray-300 hover:text-white transition">{t.privacy}</a></li>
              <li><a href="/terms.html" className="text-gray-300 hover:text-white transition">{t.terms}</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-700 pt-8 text-center">
          <p className="text-gray-300" style={{ fontFamily: 'Lato, sans-serif' }}>
            {t.copyright}
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
